var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 22.22 25.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paperclip-solid_2_",
    "data-name": "paperclip-solid (2)",
    d: "M22.389,13.23a3.159,3.159,0,0,0-4.466,0l-9.3,9.3a5.445,5.445,0,0,0,7.7,7.7l7.68-7.68a1.415,1.415,0,0,1,2,2l-7.68,7.68a8.274,8.274,0,0,1-11.7-11.7l9.3-9.3A5.988,5.988,0,0,1,24.39,19.7L15.5,28.59a3.7,3.7,0,0,1-5.234-5.234l7.276-7.276a1.415,1.415,0,0,1,2,2l-7.276,7.276A.872.872,0,1,0,13.5,26.589L22.389,17.7a3.159,3.159,0,0,0,0-4.466Z",
    transform: "translate(-4.2 -9.475)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.3092fc883934f9e326032393f884eca6.svg";
export { ForwardRef as ReactComponent };